import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    meta: {
      title: 'Главная',
    },
    children: [
      {
        path: '/materials',
        component: () => import('@/views/materials/index.vue'),
        meta: {
          title: 'Материалы',
        },
        children: [
          {
            path: '',
            name: 'materials',
            component: () => import('@/views/materials/list.vue'),
          },
          {
            path: 'categories',
            name: 'materials.category',
            component: () => import('@/views/materials/categories/index.vue'),
            meta: {
              title: 'Категории',
            },
            children: [
              {
                path: '',
                name: 'materials.category.list',
                component: () =>
                  import('@/views/materials/categories/list.vue'),
              },
              {
                path: 'add',
                name: 'materials.category.add',
                component: () => import('@/views/materials/categories/add.vue'),
                meta: {
                  title: 'Добавить',
                },
              },
              {
                path: ':id(\\d+)/edit',
                name: 'materials.category.edit',
                props: true,
                component: () =>
                  import('@/views/materials/categories/edit.vue'),
                meta: {
                  title: 'Изменить',
                },
              },
            ],
          },
        ],
      },
      {
        path: '/products',
        component: () => import('@/views/products/index.vue'),
        meta: {
          title: 'Продукты',
        },
        children: [
          {
            path: '',
            name: 'products',
            component: () => import('@/views/products/list.vue'),
          },
          {
            path: 'add',
            name: 'add.product',
            component: () => import('@/views/products/add.vue'),
            meta: {
              title: 'Добавить',
            },
          },
          {
            path: ':id(\\d+)/edit',
            name: 'edit.product',
            props: true,
            component: () => import('@/views/products/edit.vue'),
            meta: {
              title: 'Изменить',
            },
          },
          {
            path: 'categories',
            name: 'products.category',
            component: () => import('@/views/products/categories/index.vue'),
            meta: {
              title: 'Категории',
            },
            children: [
              {
                path: '',
                name: 'products.category.list',
                component: () => import('@/views/products/categories/list.vue'),
              },
              {
                path: 'add',
                name: 'product.category.add',
                component: () => import('@/views/products/categories/add.vue'),
                meta: {
                  title: 'Добавить',
                },
              },
              {
                path: ':id(\\d+)/edit',
                name: 'product.category.edit',
                props: true,
                component: () => import('@/views/products/categories/edit.vue'),
                meta: {
                  title: 'Изменить',
                },
              },
            ],
          },
        ],
      },

      {
        path: '/categories',
        name: 'categories',
        component: () => import('@/views/index.vue'),
        meta: {
          title: 'Категории',
        },
      },
      {
        path: '/works',
        name: 'works',
        component: () => import('@/views/index.vue'),
        meta: {
          title: 'Работы',
        },
      },
      {
        path: '/specialists',
        name: 'specialists',
        component: () => import('@/views/index.vue'),
        meta: {
          title: 'Специалисты',
        },
      },
      {
        path: '/places',
        name: 'places',
        component: () => import('@/views/index.vue'),
        meta: {
          title: 'Места',
        },
      },
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/login.vue'),
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/pages/Register'),
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      need_auth: false,
    },
    component: () => import('@/views/login.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
